import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import type { Component } from '@wix/thunderbolt-becky-types'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { isRefArray } from '../../utils/variantsUtils'

export const transformations = createCssCompNode('transformations', 'transformations', {
	getDependencies: (component: Component, refs: FeatureRefs<'transformations'>) =>
		component.transformationQuery
			? {
				transformationRefArray: refs.transformationQuery(component.transformationQuery),
				globalIgnoredTransformProps: envRefs.globalIgnoredTransformProps,
				ignoredTransformPropsForComp: envRefs.compIdToIgnoredTransformProps(component.id),
				ignoredTransformPropsForType: envRefs.ignoredTransformPropsForType(component.type),
				isMobileView: envRefs.isMobileView,
				vhScalingFactor: envRefs.vhScalingFactor,
			}
			: null,
	toViewItem: (component, data) => {
		if (!data || !isRefArray(data.transformationRefArray)) {
			return null
		}

		const {
			transformationRefArray,
			globalIgnoredTransformProps,
			ignoredTransformPropsForType,
			ignoredTransformPropsForComp,
			vhScalingFactor,
		} = data

		const breakpointToTransformation = toBreakpointVariantsMap(transformationRefArray.values, (x) => x)
		const ignoredTransformProps =
			ignoredTransformPropsForComp ?? ignoredTransformPropsForType ?? globalIgnoredTransformProps ?? []

		return {
			breakpointToTransformation,
			ignoredTransformProps,
			vhScalingFactor,
			...(component.layout && { defaultRotationInDegrees: component.layout.rotationInDegrees }),
		}
	},
})
